import React, { Fragment } from "react";
import "./schedules.css";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

function LaundryInstructions() {
  return (
    <Box sx={{ width: "80%" }}>
      <Typography sx={{ marginTop: 5 }}>
        <b>Reglas</b>
      </Typography>
      <Typography>
        - Los espacios libres en el calendario están disponibles para quienes no
        pudieron utilizar su espacio asignado.
      </Typography>
      <Typography>
        - Si necesita lavar en un horario que no le ha sido asignado, por favor
        coordine con la persona que tiene el turno asignado. De lo contrario, la
        persona con el turno asignado tendrá prioridad.
      </Typography>
      <Typography>
        - Los equipos tienen una carga máxima. Superar esta carga puede quemar
        el motor. 1) Lavadora: Carga máxima 15 kilos 2) Secadora: Carga máxima
        10 kilos
      </Typography>
      <Typography>
        - No lavar objetos duros como zapatos ya que dañan el equipo.
      </Typography>
      <Typography>
        - Limpiar el filtro de la secadora después de usarla. Y antes de usarla
        verificar que el filtro esté limpio.
      </Typography>
      <Typography>
        - Los botones de la lavadora y secadora son táctiles, deben funcionar al
        tocarlos suavemente. En caso de que estén duros o necesiten varios
        clicks para funcionar, por favor avisarnos para revisar.
      </Typography>
    </Box>
  );
}

// Función para crear datos de las filas
function createData(
  horary: string,
  monday: string,
  tuesday: string,
  wednesday: string,
  thursday: string,
  friday: string,
  saturday: string,
  sunday: string
) {
  return {
    horary,
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
    sunday,
  };
}

// Datos de las filas basados en el calendario proporcionado
const rows = [
  createData(
    "7:00-10:00",
    "Habitación #1 - Suiza",
    "Espacio Libre",
    "Habitación #8 - Amsterdam",
    "Habitación #11 - Japón",
    "Habitación #2 - Guatemala",
    "Habitación #5 - Londres",
    "Habitación #9 - Nueva York"
  ),
  createData(
    "10:00-13:00",
    "Habitación #2 - Guatemala",
    "Habitación #5 - Londres",
    "Espacio Libre",
    "Habitación #12 - ",
    "Habitación #3 - San José",
    "Habitación #6 - París",
    "Habitación #10 -  Machu Picchu"
  ),
  createData(
    "13:00-16:00",
    "Habitación #3 - San José",
    "Habitación #6 - París",
    "Habitación #9 -Nueva York ",
    "Espacio Libre",
    "Habitación #4 - India ",
    "Habitación #7 - Grecia",
    "Habitación #11 - Japón"
  ),
  createData(
    "16:00-20:00",
    "Habitación #4 - India",
    "Habitación #7 - Grecia",
    "Habitación #10 -  Machu Picchu",
    "Habitación #1 - Suiza",
    "Espacio Libre",
    "Habitación #8 - Amsterdam",
    "Habitación #12 - "
  ),
];

function Schedules() {
  const inventory = [
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Domingo",
  ];

  function findSpacefree(data: string) {
    if (data === "Espacio Libre") {
      return "free-schedule";
    }
  }

  return (
    <Fragment>
      <Typography variant="h3" component="h1" gutterBottom>
        Calendario Semanal de Lavandería
      </Typography>
      <Box sx={{ width: "90vw", overflow: "hidden" }}>
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center">Hora</TableCell>
                {inventory.map((day) => (
                  <TableCell key={day} align="center">
                    {day}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => {
                return (
                  <TableRow key={row.horary}>
                    <TableCell
                      component="th"
                      scope="row"
                      align="center"
                      style={{ backgroundColor: "#8f7f0b" }}
                    >
                      {row.horary}
                    </TableCell>
                    <TableCell align="center" color="text.primary">
                      {row.monday}
                    </TableCell>
                    <TableCell
                      align="center"
                      className={findSpacefree(row.tuesday)}
                    >
                      {row.tuesday}
                    </TableCell>
                    <TableCell
                      align="center"
                      className={findSpacefree(row.wednesday)}
                    >
                      {row.wednesday}
                    </TableCell>
                    <TableCell
                      align="center"
                      className={findSpacefree(row.thursday)}
                    >
                      {row.thursday}
                    </TableCell>
                    <TableCell
                      align="center"
                      className={findSpacefree(row.friday)}
                    >
                      {row.friday}
                    </TableCell>
                    <TableCell
                      align="center"
                      className={findSpacefree(row.saturday)}
                    >
                      {row.saturday}
                    </TableCell>
                    <TableCell
                      align="center"
                      className={findSpacefree(row.sunday)}
                    >
                      {row.sunday}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <LaundryInstructions />
    </Fragment>
  );
}

export default Schedules;
